<template>
    <div  class="alarmsBg">
        <div class="tableSelect_alarms" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <!-- <el-form-item label="查询时间：">
                    <el-date-picker
                            style="width:340px"
                            v-model="timers"
                            type="daterange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker> 
                </el-form-item> -->
                <el-form-item label="开始时间：">  
                    <el-date-picker  
                            style="width:140px"  
                            v-model="startDate"  
                            type="date"  
                            @change="startTimeChange"  
                    ></el-date-picker>  
                </el-form-item>  
                <el-form-item label="结束时间：">  
                    <el-date-picker  
                            style="width:140px"  
                            v-model="endDate"  
                            type="date"  
                            @change="endTimeChange"  
                    ></el-date-picker>  
                </el-form-item>
                <el-form-item label="设备名称：">
                    <el-input size="default" v-model.trim="formInline.deviceName" maxlength="30" placeholder="设备名称" clearable  style="width:130px"></el-input>
                </el-form-item>

                <el-form-item label="测点名称：">
                    <el-input size="default" v-model.trim="formInline.sensor_name" maxlength="30" placeholder="测点名称：" clearable  style="width:130px"></el-input>
                </el-form-item>

                <el-form-item label="报警类型：">
                    <el-select v-model="formInline.method" placeholder="请选择" size="default" clearable  style="width:120px">
                        <el-option
                                v-for="item in methodList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="设备类型：">
                    <el-select v-model="formInline.deviceType" placeholder="请选择" size="default" clearable  style="width:100px">
                        <el-option
                                v-for="item in deviceList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->

                <!-- <el-form-item label="告警等级：">
                    <el-select v-model="formInline.level" placeholder="请选择" size="default" clearable  style="width:100px">
                        <el-option
                                v-for="item in alarmsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->

                <el-button  @click="search" type="primary" icon="Search" style="margin-left: 40px;">查询</el-button>
                <el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button>
            </el-form>
        </div>

        <div class="table">
            <el-table  :height="'calc('+(tableHeight)+'px)'" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column width="80" type="index" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="50" prop="transform_type" label="故障类型" align="center"></el-table-column>
                <!-- <el-table-column min-width="50" prop="transform_device_type" label="设备类型" align="center"></el-table-column> -->
                <el-table-column min-width="50" prop="sensor_name" label="测点名称" align="center"></el-table-column>
                <el-table-column min-width="70" prop="device_name" label="设备名称" align="center"></el-table-column>
                <el-table-column min-width="150" prop="fault_id" label="故障ID" align="center">  </el-table-column>  
                <!-- <el-table-column min-width="50" prop="transform_level" label="故障等级" align="center"></el-table-column> -->
                <el-table-column min-width="50" prop="transform_method" label="报警类型" align="center"></el-table-column>
                <el-table-column min-width="90" prop="time" label="告警时间" align="center"></el-table-column>
                <el-table-column min-width="60" prop="transform_state" label="处理状态" align="center"></el-table-column>
                <!-- <el-table-column min-width="1" prop="id"  v-if=false></el-table-column> -->

                <el-table-column label="操作" fixed="right" width="150" align="center">
                    <template #default="scope">
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'info')" >详情</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <faultInfo ref="faultInfoFlag" @handleInfo="handleInfo" ></faultInfo>
        <faultHandle ref="faultHandleFlag" @updataConfirm="fnupdataConfirm"></faultHandle>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {dateFormats,getTableHeight} from "@/utils/util";
    import {apiAlarmslist,apiAlarmsDelete} from '@/api/api';
    import faultInfo from "@/components/fault/faultInfo";
    import faultHandle from "@/components/fault/faultHandle";
    import { getStore } from '../../utils/util';

    export default {
        components:{
            Pagination,
            faultInfo,
            faultHandle
        },
        emits: ['handleInfo', 'updataConfirm'],
        name:'alarmsPull',
        data() {
            return {
                isFull:false,
                tableHeight:500,
                loadingPage:false,
                formInline:{
                    deviceName: null,
                    method: null,
                    sensor_name:null
                },
                pageparm: {
                    page: 1,
                    page_size: 10,
                    total: 0
                },

                tableData:[],
                timers:[],
                // alarmsList:[
                //     {id:0,name:'全部'},
                //     {id:1,name:'预警'},
                //     {id:2,name:'轻微'},
                //     {id:3,name:'普通'},
                //     {id:4,name:'高危'},
                // ],
                // deviceList:[
                //     {id:0,name:'全部'},
                //     {id:1,name:deviceTypeConfig.DEVICE_TYPE_1},
                //     {id:2,name:deviceTypeConfig.DEVICE_TYPE_2},
                //     {id:3,name:deviceTypeConfig.DEVICE_TYPE_3},
                //     {id:4,name:deviceTypeConfig.DEVICE_TYPE_4},
                // ],
                methodList:[
                    {id:0,name:'全部'},
                    {id:1,name:'智能报警'},
                    {id:2,name:'固定高报'},
                    {id:3,name:'固定高高报'},
                    {id:4,name:'故障预警'},
                ],
                fnParm:{
                    page: 1,
                    page_size: 10,
                    level: null,
                    device_name: null,
                    sensor_name_exact:null,     
                    c: null,   
                    time_before: null,
                    ordering:"processed,-time",         
                },

                tableLineData:{
                },

                startDate:[],
                endDate:[],

            }
        },
        methods:{
            dataChange(item){
                this.tableData.length = 0
                for(let i = 0;i<item.length;i++){
                    this.tableData[i] = {};

                    this.tableData[i] = item[i]
                    // switch(item[i].device_type){
                    //     case 1:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_1 ;break;
                    //     case 2:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_2 ;break;
                    //     case 3:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_3 ;break;
                    //     case 4:  this.tableData[i].transform_device_type=deviceTypeConfig.DEVICE_TYPE_4 ;break;
                    //     default: this.tableData[i].transform_device_type="未定义" ;break;
                    // }
                    
                    switch(item[i].method){
                        case 1:  this.tableData[i].transform_method="智能报警";break;
                        case 2:  this.tableData[i].transform_method="固定高报";break;
                        case 3:  this.tableData[i].transform_method="固定高高报";break;
                        case 4:  this.tableData[i].transform_method="故障预警";break;
                        default: this.tableData[i].transform_method="未定义" ;break;
                    }

                    if(item[i].fault_id == null || item[i].fault_id == "")
                        this.tableData[i].fault_id = '-'
                    else
                        this.tableData[i].fault_id    = item[i].fault_id

                    if(item[i].time == null || item[i].time == "")
                        this.tableData[i].time = '-'
                    else
                        this.tableData[i].time    = item[i].time

                    //保留，详情中显示    
                    switch(item[i].level){
                        case 0:  this.tableData[i].transform_level="健康" ;break;
                        case 1:  this.tableData[i].transform_level="预警" ;break;
                        case 2:  this.tableData[i].transform_level="轻微" ;break;
                        case 3:  this.tableData[i].transform_level="普通" ;break;
                        case 4:  this.tableData[i].transform_level="高危" ;break;
                        default: this.tableData[i].transform_level="未定义" ;break;
                    }
                         
                    if(item[i].processed)
                        this.tableData[i].transform_state="已处理" ;
                    else
                        this.tableData[i].transform_state="未处理" ;

                    if(item[i].state == 4 && item[i].processed){
                        switch(item[i].processed_type){
                            case 0:   this.tableData[i].transform_type="空" ;break;
                            case 1: this.tableData[i].transform_type="停机" ;break;
                            case 99: this.tableData[i].transform_type="其他故障" ;break;
                            case 100: this.tableData[i].transform_type="模拟故障" ;break;
                            case 101: this.tableData[i].transform_type="转子不对中" ;break;
                            case 102: this.tableData[i].transform_type="转子不平衡" ;break;
                            case 103: this.tableData[i].transform_type="轴弯曲" ;break;
                            case 104: this.tableData[i].transform_type="轴裂纹" ;break;
                            case 105: this.tableData[i].transform_type="轴承松动" ;break;
                            case 106: this.tableData[i].transform_type="滚动轴承故障" ;break;
                            case 107: this.tableData[i].transform_type="滑动轴承故障" ;break;
                            case 201: this.tableData[i].transform_type="UPS温度过高" ;break;
                            case 202: this.tableData[i].transform_type="UPS电源局部放电" ;break;
                            case 203: this.tableData[i].transform_type="UPS电源机械性故障" ;break;                            
                            case 301: this.tableData[i].transform_type="空调压缩机故障" ;break;
                            case 401: this.tableData[i].transform_type="变压器局部放电" ;break;
                            case 402: this.tableData[i].transform_type="变压器绕组形变" ;break;
                            case 403: this.tableData[i].transform_type="变压器部件松动" ;break;
                            case 404: this.tableData[i].transform_type="变压器直流偏磁" ;break;
                            case 901: this.tableData[i].transform_type="电流异常" ;break;
                            case 1001:this.tableData[i].transform_type="温度异常" ;break;
                            default:  this.tableData[i].transform_type="未定义" ;break;
                        }
                    }else{
                        switch(item[i].type){
                            case 0:   this.tableData[i].transform_type="空" ;break;
                            case 1: this.tableData[i].transform_type="停机" ;break;
                            case 99: this.tableData[i].transform_type="其他故障" ;break;
                            case 100: this.tableData[i].transform_type="模拟故障" ;break;
                            case 101: this.tableData[i].transform_type="转子不对中" ;break;
                            case 102: this.tableData[i].transform_type="转子不平衡" ;break;
                            case 103: this.tableData[i].transform_type="轴弯曲" ;break;
                            case 104: this.tableData[i].transform_type="轴裂纹" ;break;
                            case 105: this.tableData[i].transform_type="轴承松动" ;break;
                            case 106: this.tableData[i].transform_type="滚动轴承故障" ;break;
                            case 107: this.tableData[i].transform_type="滑动轴承故障" ;break;
                            case 201: this.tableData[i].transform_type="UPS温度过高" ;break;
                            case 202: this.tableData[i].transform_type="UPS电源局部放电" ;break;
                            case 203: this.tableData[i].transform_type="UPS电源机械性故障" ;break;                            
                            case 301: this.tableData[i].transform_type="空调压缩机故障" ;break;
                            case 401: this.tableData[i].transform_type="变压器局部放电" ;break;
                            case 402: this.tableData[i].transform_type="变压器绕组形变" ;break;
                            case 403: this.tableData[i].transform_type="变压器部件松动" ;break;
                            case 404: this.tableData[i].transform_type="变压器直流偏磁" ;break;
                            case 901: this.tableData[i].transform_type="电流异常" ;break;
                            case 1001: this.tableData[i].transform_type="温度异常" ;break;
                            default:  this.tableData[i].transform_type="未定义" ;break;
                        }
                    }
                }
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
            setFull(){
                this.isFull=!this.isFull
            },

            handleEdit(row,flag) {
                if(flag=='edit') {
                    
                }
                else if(flag == 'detail') {
                    
                }
                else if(flag == 'authority') {
                    // this.$router.push({name:'authorityManage',params:{id:row.id}})//已失效
                    //this.$router.push({name:'authorityManage',state:{id:row.id}})
                    // this.$router.push({name:'authorityManage',query:{id:row.id}})
                }
                else if(flag=='delete') {
                    let vm = this
                    vm.$confirm('您确定要删除选中的事件？',{
                        closeOnClickModal:false
                    }).then(()=>{
                        // apiAlarmsDelete({id:row.id}).then(res=>{
                        //     if(res.code == 404) {
                        //         vm.$message.warning(res.msg)
                        //     } else {
                        //         vm.$message.success("删除成功")
                        //         vm.search()
                        //     }
                        // })
                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                    this.fnParm = {
                        page:1,
                        page_size: 10,
                        ordering:"processed,-time",
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                    this.formInline = {}
                    this.timers.length = 0

                    this.startDate = ""
                    this.endDate = ""
                    
                    this.getData()
                }
                else if(flag == "info"){
                    this.tableLineData = row
                   
                    this.faultInfoFn(row)
                }
            },

            callFather(parm) {
                this.fnParm.page = parm.page
                this.fnParm.page_size = parm.page_size
                this.fnParm.ordering = "processed,-time",
                this.getData()
            },

            search() {
                var dataCount = 0
                if(!(this.startDate == "" || this.startDate == null) ){
                    dataCount += 1
                }
                if(!(this.endDate == "" || this.endDate == null) ){
                    dataCount += 1
                }
                if(dataCount == 1){
                    this.$message.warning("查询时间设置不完整！")
                    return;
                }
                
                this.fnParm.page_size = this.pageparm.page_size
                this.pageparm.page = 1
                this.fnParm.page = this.pageparm.page

                this.fnParm.ordering = "processed,-time",
                // this.fnParm.page = 1   //成功后，选1之后，有问题？
                // this.fnParm.page_size = 10

                this.fnParm.device_name = this.formInline.deviceName
                if(this.fnParm.device_name == '')
                    this.fnParm.device_name = null
                this.fnParm.method = this.formInline.method
                if(this.fnParm.method == 0)
                    this.fnParm.method = null

                this.fnParm.sensor_name_exact = this.formInline.sensor_name
                if(this.fnParm.sensor_name_exact == 0)
                    this.fnParm.sensor_name_exact = null
   
                this.getData()
            },
            //获取列表
            async getData(){
                 this.loadingPage = true

                 apiAlarmslist(this.fnParm).then(res => {
                    this.loadingPage = false
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        //this.tableData = res.data.data.items;
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }).catch(res => {  
                    this.loadingPage = false
                    this.tableData.length = 0
                    this.$message.error(`获取告警列表失败 : ${res.msg}`)
                });           
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
               var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
               this.tableHeight =  getTableHeight(this.$refs.tableSelect.offsetHeight) - 2*bg_padding
            },

            faultInfoFn(row){
                let title = "故障告警/告警详情：" + row.device_name
                this.$refs.faultInfoFlag.faultInfoFn(row,title)
            },

            handleInfo(flag){
                if(flag == 'comfirm'){
                    //this.$refs.faultHandleFlag.faultHandleFn(this.tableLineData,"告警处理")
                } else if(flag == 'quit') {
                    this.search()
                }
                // this.tableLineData = {}
            },

            fnupdataConfirm(flag){
                //待确认
            },

            startTimeChange(val){
                if (val) {
                    const start = new Date(val)
                    const startStr = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`
                    this.fnParm.time_after = startStr

                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(start.getTime() > todayIntegralPoint.getTime()){
                        this.startDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                        this.fnParm.time_after = null
                    }else {
                        if(!(this.endDate == "" || this.endDate == null)){
                            const end = new Date(this.endDate)
                            if(start.getTime() > end.getTime()){
                                this.startDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                                this.fnParm.time_after = null
                            }
                        }
                    }
                } else {
                    this.fnParm.time_after = null
                } 
            },

            endTimeChange(val){
                if (val) {
                    const end = new Date(val)
                    const endStr = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`
                    this.fnParm.time_before = endStr

                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(end.getTime() > todayIntegralPoint.getTime()){
                        this.endDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                        this.fnParm.time_before = null
                    }else {
                        if(!(this.startDate == "" || this.startDate == null)){
                            const start = new Date(this.startDate)
                            if(start.getTime() > end.getTime()){
                                this.endDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                                this.fnParm.time_before = null
                            }
                        }
                    }
                } else {
                    this.fnParm.time_before = null
                } 
            },

            timeChange(val){
                if (val) {
                    // this.fnParm.time_before=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
                    // this.fnParm.time_after=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
                    const start = new Date(val[0])
                    const startStr = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`

                    const end = new Date(val[1])
                    const endStr = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`

                    this.fnParm.time_before = endStr
                    this.fnParm.time_after = startStr
                } else {
                    this.fnParm.time_before = null
                    this.fnParm.time_after = null
                }
                
                // this.search()
            },


        },


        created() {
           
        },

        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
            let userName = getStore('userName')
            if( userName != 'nmyh'){
               console.log('fffffffff',userName)
               this.getData()
            }
          
           
        },
        unmounted() {
              // 页面销毁，去掉监听事件
            window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss" scoped>
    .tableNav{
        overflow: hidden;
        margin-bottom: 20px;
    }

    .alarmsBg{
      background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
    //   background: #000;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      padding: var(--my-css-var-bg-padding);
    }

    .tableSelect_alarms{
        background: var(--l-searchtoolbar-bg);
        padding: 8px;


        border: 1px solid var(--el-border-color-lighter);
        margin-bottom: 8px;

        .el-form-item{
            margin: 5px !important;
        }
    }
</style>
